

// *************************************************************************
import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card, Tabs, Collapse, Button, Modal, Typography, Spin, Alert, Badge, List, Radio, Checkbox } from "antd";
import { CaretRightOutlined, EyeOutlined, PaperClipOutlined, ReadOutlined, BookOutlined, FileTextOutlined, TrophyOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";
import authHeader from "../../services/auth-header";
import API_BASE from "../../config/apiConfig";
import QuizComponent from "./QuizComponent";
import TrainingTable from "./TrainingViewer";
import TrainingViewer from "./TrainingViewer";
import QuizPreviewComponent from "./QuizPreviewComponent";

const { Text } = Typography;
const API_BASE_URL = `${API_BASE}/images/proxy`;

const CourseDetails = () => {
    const contentRef = React.useRef(null);

    const { id } = useParams();
    const [subjects, setSubjects] = useState([]);
    const [groupedSubjects, setGroupedSubjects] = useState({});
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);
    const [selectedContent, setSelectedContent] = useState("");
    const [activeGroup, setActiveGroup] = useState("");
    const [quizzes, setQuizzes] = useState({});
    const [isQuizModalVisible, setIsQuizModalVisible] = useState(false);
    const [selectedQuizId, setSelectedQuizId] = useState(null);
    const [courseDetails, setCourseDetails] = useState({});
    const [imageUrl, setImageUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [completedSubjects, setCompletedSubjects] = useState({});
    const [isQuizLoading, setIsQuizLoading] = useState(false); // 🔥 Ajout de l'état de chargement
    const [quizSuccessMessage, setQuizSuccessMessage] = useState(null);  // Nouvel état pour stocker le message de succès
    const [quizResults, setQuizResults] = useState({});  // Stocke le statut du quiz (correct ou incorrect)
    const [triggerRefresh, setTriggerRefresh] = useState(false);

    const [trainings, setTrainings] = useState([]);
    const [isTrainingsModalVisible, setIsTrainingsModalVisible] = useState(false);
    const [quizCompleted, setQuizCompleted] = useState({}); // Stocke les quiz terminés

    const [visitedSubjects, setVisitedSubjects] = useState({}); // Nouvel état
    const [attachmentsMap, setAttachmentsMap] = useState({});


    const [courseQuizzes, setCourseQuizzes] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [resources, setResources] = useState([]);
    const [displayMode, setDisplayMode] = useState("full"); // full | attachments | resources

    const attachmentsRef = React.useRef(null);
    const resourcesRef = React.useRef(null);
    const [resourcesMap, setResourcesMap] = useState({});


    const [isAttachmentsModalVisible, setIsAttachmentsModalVisible] = useState(false);
    const [isResourcesModalVisible, setIsResourcesModalVisible] = useState(false);

    const openAttachmentsModal = () => setIsAttachmentsModalVisible(true);
    const closeAttachmentsModal = () => setIsAttachmentsModalVisible(false);

    const openResourcesModal = () => setIsResourcesModalVisible(true);
    const closeResourcesModal = () => setIsResourcesModalVisible(false);



    const handleQuizSubmit = (subjectId, isCorrect) => {
        console.log(`Quiz soumis pour ${subjectId}, est correct ?`, isCorrect);

        setQuizCompleted((prevState) => ({
            ...prevState,
            [subjectId]: true,  // ✅ Marque ce quiz comme complété
        }));

        setQuizResults((prevState) => ({
            ...prevState,
            [subjectId]: isCorrect,  // ✅ Stocke le résultat du quiz (true = correct, false = incorrect)
        }));

        setQuizSuccessMessage("Quiz soumis avec succès !");
    };



    useEffect(() => {
        fetchTrainings();
    }, [id]);

    const handleQuizCompletion = async (subjectId) => {
        if (quizzes[subjectId] && quizzes[subjectId].length > 0) {
            setIsQuizLoading(true);  // 🔥 Active le spinner

            const selectedQuiz = quizzes[subjectId][0].id;
            setSelectedQuizId(selectedQuiz);
            setIsQuizModalVisible(true);

            setTimeout(() => {
                setIsQuizLoading(false); // 🔥 Désactive le spinner après chargement
            }, 1000); // Simule un temps de chargement
        }

        // ❌ Ne plus mettre à jour completedSubjects ici
    };



    const markSubjectAsCompleted = (subjectId) => {
        setCompletedSubjects((prevState) => ({
            ...prevState,
            [subjectId]: true,
        }));
    };

    // **** pour desactiver le clique droit ***
    useEffect(() => {
        const disableRightClick = (e) => e.preventDefault();

        document.addEventListener("contextmenu", disableRightClick);

        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
        };
    }, []);


    // useEffect(() => {
    //     const fetchCourseData = async () => {
    //         setLoading(true);
    //         try {


    //             const quizzesData = await courseService.getQuizzesByCourse(id);

    //             // Charger toutes les questions pour chaque quiz
    //             const quizzesWithQuestions = await Promise.all(
    //                 quizzesData.map(async (quiz) => {
    //                     const questions = await courseService.getQuestionsByQuiz(quiz.id);

    //                     // 🔥 Maintenant charger aussi les options (réponses) pour chaque question
    //                     const questionsWithOptions = await Promise.all(
    //                         questions.map(async (question) => {
    //                             const options = await courseService.getAnswersByQuestion(question.id);
    //                             return { ...question, options };
    //                         })
    //                     );


    //                     return { ...quiz, questions: questionsWithOptions };
    //                 })
    //             );

    //             setCourseQuizzes(quizzesWithQuestions);


    //             // const attachmentsData = await courseService.getAttachmentsByCourse(id);
    //             // setAttachments(attachmentsData);

    //             // const resourcesData = await courseService.getResourcesByCourse(id);
    //             // setResources(resourcesData);






    //             // Récupérer les matières du cours
    //             const subjectsData = await courseService.getSubjectsByCourse(id);
    //             setSubjects(subjectsData);

    //             // const grouped = subjectsData.reduce((acc, subject) => {
    //             //     const { group_name } = subject;
    //             //     if (!acc[group_name]) acc[group_name] = [];
    //             //     acc[group_name].push(subject);
    //             //     return acc;
    //             // }, {});
    //             // setGroupedSubjects(grouped);
    //             const grouped = subjectsData.reduce((acc, subject) => {
    //                 const { group_name, title } = subject;

    //                 if (!acc[group_name]) acc[group_name] = {};
    //                 if (!acc[group_name][title]) acc[group_name][title] = [];

    //                 acc[group_name][title].push(subject);
    //                 return acc;
    //             }, {});
    //             // alert(JSON.stringify(grouped))
    //             setGroupedSubjects(grouped);


    //             // const grouped = subjectsData.reduce((acc, subject) => {
    //             //     const { group_name, title, subTitle, content } = subject;

    //             //     if (!acc[group_name]) acc[group_name] = {};
    //             //     if (!acc[group_name][title]) acc[group_name][title] = { main: null, sub: [], index: Object.keys(acc[group_name]).length + 1 };

    //             //     if (subTitle && subTitle.trim() !== "") {
    //             //         acc[group_name][title].sub.push({
    //             //             title: subTitle,
    //             //             content,
    //             //             index: acc[group_name][title].sub.length + 1
    //             //         });
    //             //     } else {
    //             //         acc[group_name][title].main = { title, content };
    //             //     }

    //             //     return acc;
    //             // }, {});

    //             // setGroupedSubjects(grouped);


    //             if (subjectsData.length > 0) {
    //                 setSelectedSubjectId(subjectsData[0].id);
    //                 setSelectedContent(subjectsData[0].content);
    //                 setActiveGroup(subjectsData[0].group_name);
    //             }

    //             // Récupération des détails du cours
    //             const courseData = await courseService.getCourseDetails(id);
    //             setCourseDetails(courseData);

    //             // Récupération de l'image via proxy
    //             const imageProxyUrl = await fetchImage(courseData.image);
    //             setImageUrl(imageProxyUrl);



    //             const attachmentsPromises = subjectsData.map(async (subject) => {
    //                 const subjectAttachments = await courseService.getAttachmentsBySubject(subject.id);
    //                 return { subjectId: subject.id, attachments: subjectAttachments };
    //             });
    //             const allAttachments = await Promise.all(attachmentsPromises);

    //             const newAttachmentsMap = {};
    //             allAttachments.forEach(({ subjectId, attachments }) => {
    //                 newAttachmentsMap[subjectId] = attachments;
    //             });
    //             setAttachmentsMap(newAttachmentsMap);
    //             setTriggerRefresh(prev => !prev);


    //         } catch (err) {
    //             console.error("Erreur lors de la récupération des données :", err);
    //             setError("Impossible de charger les données.");
    //         } finally {
    //             setLoading(false);
    //         }
    //     };
    //     fetchCourseData();



    const fetchTrainings = async () => {
        try {
            const response = await courseService.getTrainingsByCourse(id);
            console.log("🔍 Trainings reçus :", response);
            const trainingsArray = response.data || [];
            setTrainings(trainingsArray);
        } catch (err) {
            console.error("Erreur chargement exercices :", err);
        }
    };


    // }, [id]);
    useEffect(() => {
        const fetchCourseData = async () => {
            setLoading(true);
            try {
                const quizzesData = await courseService.getQuizzesByCourse(id);

                const quizzesWithQuestions = await Promise.all(
                    quizzesData.map(async (quiz) => {
                        const questions = await courseService.getQuestionsByQuiz(quiz.id);
                        const questionsWithOptions = await Promise.all(
                            questions.map(async (question) => {
                                const options = await courseService.getAnswersByQuestion(question.id);
                                return { ...question, options };
                            })
                        );
                        return { ...quiz, questions: questionsWithOptions };
                    })
                );
                setCourseQuizzes(quizzesWithQuestions);
// ✅ Ajoute ceci pour afficher tous les quiz avec leur attempt_once
console.log("🎯 Contrôles des connaissances récupérés :", quizzesWithQuestions.map(q => ({
    id: q.id,
    title: q.title,
    attempt_once: q.attempt_once
  })));
                const subjectsData = await courseService.getSubjectsByCourse(id);
                setSubjects(subjectsData);

                const grouped = subjectsData.reduce((acc, subject) => {
                    const { group_name, title } = subject;
                    if (!acc[group_name]) acc[group_name] = {};
                    if (!acc[group_name][title]) acc[group_name][title] = [];
                    acc[group_name][title].push(subject);
                    return acc;
                }, {});
                setGroupedSubjects(grouped);

                if (subjectsData.length > 0) {
                    const firstSubject = subjectsData[0];
                    setSelectedSubjectId(firstSubject.id);
                    setSelectedContent(firstSubject.content);
                    setActiveGroup(firstSubject.group_name);

                    // ✅ Charger les ressources du premier sujet
                    const subjectResources = await courseService.getResourcesBySubject(firstSubject.id);
                    setResources(subjectResources || []);
                }

                const courseData = await courseService.getCourseDetails(id);
                setCourseDetails(courseData);

                const imageProxyUrl = await fetchImage(courseData.image);
                setImageUrl(imageProxyUrl);

                const attachmentsPromises = subjectsData.map(async (subject) => {
                    const subjectAttachments = await courseService.getAttachmentsBySubject(subject.id);
                    return { subjectId: subject.id, attachments: subjectAttachments };
                });
                const allAttachments = await Promise.all(attachmentsPromises);

                const newAttachmentsMap = {};
                allAttachments.forEach(({ subjectId, attachments }) => {
                    newAttachmentsMap[subjectId] = attachments;
                });
                setAttachmentsMap(newAttachmentsMap);
                // Charger toutes les ressources pour tous les sujets
                const resourcesPromises = subjectsData.map(async (subject) => {
                    const subjectResources = await courseService.getResourcesBySubject(subject.id);
                    return { subjectId: subject.id, resources: subjectResources };
                });
                const allResources = await Promise.all(resourcesPromises);

                const newResourcesMap = {};
                allResources.forEach(({ subjectId, resources }) => {
                    newResourcesMap[subjectId] = resources;
                });
                setResourcesMap(newResourcesMap);


                setTriggerRefresh(prev => !prev);

            } catch (err) {
                console.error("Erreur lors de la récupération des données :", err);
                setError("Impossible de charger les données.");
            } finally {
                setLoading(false);
            }
        };

        fetchCourseData();
        // fetchTrainings();
    }, [id]);

    useEffect(() => {
        if (subjects.length === 0) return;

        const fetchQuizzes = async () => {
            try {
                const allQuizzes = {};
                for (const subject of subjects) {
                    const quizData = await courseService.getQuizzesBySubject(subject.id);
                    allQuizzes[subject.id] = quizData;
                }
                setQuizzes(allQuizzes);
            } catch (err) {
                console.error("Erreur lors de la récupération des quiz :", err);
            }
        };
        fetchQuizzes();
    }, [subjects]);

    const fetchImage = async (imageUrl) => {
        try {
            const response = await fetch(`${API_BASE_URL}?url=${encodeURIComponent(imageUrl)}`, {
                headers: authHeader(),
            });
            if (!response.ok) throw new Error("Erreur lors de la récupération de l'image");
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("Erreur lors de la récupération de l'image :", error);
            return "/default-course-image.jpg";
        }
    };


    // const handleSubjectSelection = (subject) => {
    //     setSelectedSubjectId(subject.id);
    //     setSelectedContent(subject.content);
    //     setActiveGroup(subject.group_name);

    //     // Faire défiler jusqu'au début du contenu
    //     if (contentRef.current) {
    //         contentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    //     }
    // };

    const scrollToSection = (section) => {
        if (section === "attachments" && attachmentsRef.current) {
            attachmentsRef.current.scrollIntoView({ behavior: "smooth" });
        } else if (section === "resources" && resourcesRef.current) {
            resourcesRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    // const handleSubjectSelection = async (subject) => {
    //     setSelectedSubjectId(subject.id);
    //     setSelectedContent(subject.content);
    //     setActiveGroup(subject.group_name);

    //     if (contentRef.current) {
    //         contentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    //     }

    //     // 🔥 Ajouter ici pour charger les attachments et ressources du sujet
    //     try {
    //         const subjectAttachments = await courseService.getAttachmentsBySubject(subject.id);
    //         const subjectResources = await courseService.getResourcesBySubject(subject.id);

    //         setAttachments(subjectAttachments || []);

    //         setResources(subjectResources || []);


    //         console.log("subjectAttachments ===> " + JSON.stringify(subjectAttachments))

    //     } catch (error) {
    //         console.error("Erreur lors du chargement des pièces jointes et ressources :", error);
    //     }
    // };
    const location = useLocation();
    useEffect(() => {
        if (location.state?.subjectId) {
            const subject = subjects.find(s => s.id === location.state.subjectId);
            if (subject) handleSubjectSelection(subject, location.state.scrollTo);
        }
    }, [subjects, location]);

    // const handleSubjectSelection = async (subject, mode = "full") => {
    //     setSelectedSubjectId(subject.id);
    //     setActiveGroup(subject.group_name);

    //     if (mode === "full" || mode === "content") {
    //         setSelectedContent(subject.content);
    //     } else {
    //         setSelectedContent(""); // 🧼 Effacer le contenu HTML si ce n’est pas demandé
    //     }

    //     try {
    //         // const subjectAttachments = await courseService.getAttachmentsBySubject(subject.id);
    //         const subjectAttachments = attachmentsMap[subject.id] || [];

    //         const subjectResources = await courseService.getResourcesBySubject(subject.id);

    //         // setAttachments(subjectAttachments || []);
    //         // setAttachments(attachmentsMap[subject.id] || []);

    //         setResources(subjectResources || []);
    //     } catch (error) {
    //         console.error("Erreur lors du chargement des pièces jointes et ressources :", error);
    //     }

    //     if (contentRef.current) {
    //         contentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    //     }
    // };

    const handleSubjectSelection = async (subject, mode = "full") => {
        setSelectedSubjectId(subject.id);
        setActiveGroup(subject.group_name);
        setDisplayMode(mode); // ✅ enregistrer l'affichage demandé

        if (mode === "full" || mode === "content") {
            setSelectedContent(subject.content);
        } else {
            setSelectedContent(""); // vide si seulement pièces jointes ou ressources
        }

        try {
            const subjectAttachments = attachmentsMap[subject.id] || [];
            const subjectResources = resourcesMap[subject.id] || [];

            setAttachments(subjectAttachments);
            setResources(subjectResources);
        } catch (error) {
            console.error("Erreur lors du chargement :", error);
        }

        if (contentRef.current) {
            contentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const openQuizModal = (quizId) => {
        setSelectedQuizId(quizId);
        setIsQuizModalVisible(true);
    };

    const closeQuizModal = () => {
        setIsQuizModalVisible(false);
        setSelectedQuizId(null);
    };

    if (loading) {
        return (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Spin size="large" tip="Chargement des données..." />
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Alert message="Erreur" description={error} type="error" showIcon />
            </div>
        );
    }
    const sanitizeAndModifyContent = (content) => {
        if (!content) return "Veuillez sélectionner un contenu.";

        // Ajouter les attributs pour empêcher le téléchargement et désactiver le clic droit
        return content
            .replace(/<video /g, '<video oncontextmenu="return false;" controlsList="nodownload" disablePictureInPicture ')
            .replace(/<source /g, '<source oncontextmenu="return false;" ');
    };

    const findNextSubject = () => {
        const subjectList = subjects.flat(); // Convertit l'objet en liste plate
        const currentIndex = subjectList.findIndex((subject) => subject.id === selectedSubjectId);
        return currentIndex !== -1 && currentIndex < subjectList.length - 1 ? subjectList[currentIndex + 1] : null;
    };


    // const goToNextSubject = () => {
    //     const nextSubject = findNextSubject();
    //     if (nextSubject) {
    //         setVisitedSubjects((prevState) => ({
    //             ...prevState,
    //             [selectedSubjectId]: true,  // Marquer l'ancien sujet comme "visité"
    //         }));
    //         handleSubjectSelection(nextSubject);
    //     }
    // };


    const goToNextSubject = () => {
        const nextSubject = findNextSubject();
        if (nextSubject) {
            setVisitedSubjects((prevState) => ({
                ...prevState,
                [selectedSubjectId]: true,
            }));
            handleSubjectSelection(nextSubject, "full"); // ✅ Corrigé ici
        }
    };



    const isLastSubject = () => {
        return !findNextSubject();
    };
    const findPreviousSubject = () => {
        const subjectList = subjects.flat(); // Convertit en liste simple
        const currentIndex = subjectList.findIndex((subject) => subject.id === selectedSubjectId);
        return currentIndex > 0 ? subjectList[currentIndex - 1] : null;
    };

    // const goToPreviousSubject = () => {
    //     const previousSubject = findPreviousSubject();
    //     if (previousSubject) {
    //         handleSubjectSelection(previousSubject);
    //     }
    // };

    const goToPreviousSubject = () => {
        const previousSubject = findPreviousSubject();
        if (previousSubject) {
            handleSubjectSelection(previousSubject, "full"); // ✅ Corrigé ici
        }
    };


    const isFirstSubject = () => {
        return !findPreviousSubject();
    };


    // const isLastSubject = (subjectId) => {
    //     const allSubjects = Object.values(groupedSubjects).flatMap((group) =>
    //         Object.values(group).flat()
    //     );
    //     return allSubjects[allSubjects.length - 1]?.id === subjectId;
    // };


    return (
        <>
            <div className="course-details-container">
                <Tabs
                    defaultActiveKey="1"
                    size="large"
                // tabBarStyle={{
                //     fontSize: "18px",
                //     fontWeight: "bold",
                //     background: "white",
                //     position: "sticky",
                //     top: "10",
                //     zIndex: "1000",
                //     boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Ajoute une ombre pour plus de visibilité
                //     padding: "10px",
                // }}
                >
                    {/* 🏆 Tab Aperçu */}
                    <Tabs.TabPane
                        tab={
                            <span>
                                <ReadOutlined style={{ fontSize: "20px", color: "#ff9800" }} /> Aperçu
                            </span>
                        }
                        key="1"
                    >                        <Card title="Aperçu du cours">
                            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                <img
                                    src={imageUrl}
                                    alt="Course"
                                    style={{ width: "300px", height: "200px", borderRadius: "8px", objectFit: "cover" }}
                                />
                            </div>
                            <h2 style={{ color: "#4A90E2" }}>{courseDetails.title}</h2>
                            <p><strong>Durée :</strong> {courseDetails.duration || "Non spécifiée"}</p>
                            <p><strong>Leçons :</strong> {courseDetails.lessons || "Non spécifiées"}</p>
                            <p><strong>Entraînements des connaissances :</strong> {courseDetails.entrainements_des_connaissances || "Non spécifié"}</p>
                            <p><strong>Évaluation des connaissances :</strong> {courseDetails.evaluation_des_connaissances || "Non spécifié"}</p>
                            <p><strong>Contrôle des connaissances :</strong> {courseDetails.controle_des_connaissances || "Non spécifié"}</p>

                            <h3>Description courte :</h3>
                            <p>{courseDetails.short_desc}</p>

                            <h3>Aperçu :</h3>
                            <div dangerouslySetInnerHTML={{ __html: courseDetails.overview }} />

                            <h3>Prérequis :</h3>
                            <div dangerouslySetInnerHTML={{ __html: courseDetails.requirements }} />

                            <h3>Ce que vous apprendrez :</h3>
                            <div dangerouslySetInnerHTML={{ __html: courseDetails.what_you_will_learn }} />

                            <h3>À qui s'adresse ce cours :</h3>
                            <div dangerouslySetInnerHTML={{ __html: courseDetails.who_is_this_course_for }} />
                        </Card>
                    </Tabs.TabPane>

                    {/* 📖 Tab Contenu du cours */}
                    <Tabs.TabPane
                        tab={
                            <span>
                                <BookOutlined style={{ fontSize: "20px", color: "#3f51b5" }} /> Contenu du cours
                            </span>
                        }
                        key="2"
                    >
                        {/* <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}> */}
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            height: "100vh",
                            background: "#F5F5F5",
                            padding: "15px",
                        }}>

                            <div style={{ flex: "1 1 20%", padding: "15px", borderRight: "1px solid #ddd", overflowY: "auto" }}>
                                <Card>


                                    <Collapse
                                        bordered={false}
                                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                                        activeKey={activeGroup}
                                        onChange={(key) => setActiveGroup(key)}
                                    >


                                        {Object.entries(groupedSubjects).map(([groupName, subjectsByTitle], groupIndex) => (
                                            <React.Fragment key={groupName}>
                                                <div
                                                    style={{
                                                        background: "#E3F2FD",
                                                        padding: "10px",
                                                        borderRadius: "10px",
                                                        marginBottom: "15px",
                                                    }}
                                                >
                                                    <Text
                                                        strong
                                                        style={{
                                                            color: "#1565C0",
                                                            fontSize: "16px",
                                                            textTransform: "uppercase",
                                                        }}
                                                    >
                                                        {groupName}
                                                    </Text>

                                                    <Collapse bordered={false} style={{ background: "transparent", marginTop: "10px" }}>
                                                        {Object.entries(subjectsByTitle).map(([title, subjects], subjectIndex) => {
                                                            const subjectNumber = `${subjectIndex + 1}`;

                                                            return subjects.length > 1 ? (
                                                                <Collapse.Panel
                                                                    key={title}
                                                                    header={<Text strong style={{ fontSize: "14px", color: "#333" }}>{subjectNumber}. {title}</Text>}
                                                                >
                                                                    <ul style={{ listStyle: "none", padding: "0", marginTop: "5px" }}>
                                                                        {subjects.map((subject, subIndex) => {
                                                                            const subNumber = `${subjectNumber}.${subIndex + 1}`;

                                                                            return (
                                                                                <li
                                                                                    key={subject.id}
                                                                                    style={{
                                                                                        padding: "8px",
                                                                                        borderRadius: "5px",
                                                                                        background: subject.id === selectedSubjectId ? "#F0F0F0" : "#fff",
                                                                                        cursor: "pointer",
                                                                                        transition: "0.3s",
                                                                                        marginBottom: "5px",
                                                                                    }}
                                                                                    onClick={() => handleSubjectSelection(subject)}
                                                                                >
                                                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "5px" }}>
                                                                                        <Text strong>{subNumber}. {subject.subTitle || subject.title}</Text>

                                                                                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                                            {quizzes[subject.id] && quizzes[subject.id].length > 0 && (
                                                                                                <Button
                                                                                                    type="default"
                                                                                                    onClick={() => handleQuizCompletion(subject.id)}
                                                                                                    style={{
                                                                                                        border: "2px solid #FFA000",
                                                                                                        color: "#FFA000",
                                                                                                        fontWeight: "bold",
                                                                                                        padding: "6px 12px",
                                                                                                        borderRadius: "10px",
                                                                                                        fontSize: "14px",
                                                                                                    }}
                                                                                                >
                                                                                                    {quizCompleted[subject.id]
                                                                                                        ? quizResults[subject.id] !== undefined
                                                                                                            ? quizResults[subject.id]
                                                                                                                ? "✅"
                                                                                                                : "❌"
                                                                                                            : "✅"
                                                                                                        : "🤔"}{" "}
                                                                                                    Compris ?
                                                                                                </Button>
                                                                                            )}

                                                                                            {/* {attachmentsMap[subject.id] && attachmentsMap[subject.id].length > 0 && ( */}
                                                                                            {/* <Button
                                                                                                type="dashed"
                                                                                                icon={<PaperClipOutlined />}
                                                                                                onClick={() => handleSubjectSelection(subject, "attachments")}
                                                                                                style={{
                                                                                                    borderRadius: "10px",
                                                                                                    fontSize: "14px",
                                                                                                }}
                                                                                            >
                                                                                                📎 Pièces jointes
                                                                                            </Button> */}
                                                                                            {/* )} */}
                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                    </ul>
                                                                </Collapse.Panel>
                                                            ) : (
                                                                <div
                                                                    key={subjects[0].id}
                                                                    style={{
                                                                        padding: "10px",
                                                                        borderRadius: "5px",
                                                                        background: subjects[0].id === selectedSubjectId ? "#F0F0F0" : "#fff",
                                                                        cursor: "pointer",
                                                                        transition: "0.3s",
                                                                        borderBottom: "1px solid #ddd",
                                                                        marginBottom: "5px",
                                                                    }}
                                                                    onClick={() => handleSubjectSelection(subjects[0])}
                                                                >
                                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "5px" }}>
                                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "18px",
                                                                                    marginRight: "10px",
                                                                                    color:
                                                                                        quizResults[subjects[0].id] === false
                                                                                            ? "red"
                                                                                            : quizResults[subjects[0].id] === true
                                                                                                ? "green"
                                                                                                : "black",
                                                                                }}
                                                                            >
                                                                                {visitedSubjects[subjects[0].id] ? "✅" : ""}
                                                                            </span>
                                                                            <Text strong>{subjectNumber}. {subjects[0].title}</Text>
                                                                        </div>
                                                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "8px" }}>
                                                                            {quizzes[subjects[0].id] && quizzes[subjects[0].id].length > 0 && (
                                                                                <Button
                                                                                    type="default"
                                                                                    onClick={() => handleQuizCompletion(subjects[0].id)}
                                                                                    style={{
                                                                                        border: "2px solid #FFA000",
                                                                                        color: "#FFA000",
                                                                                        fontWeight: "bold",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: "8px",
                                                                                        padding: "6px 12px",
                                                                                        borderRadius: "10px",
                                                                                        fontSize: "16px",
                                                                                        transition: "0.3s",
                                                                                    }}
                                                                                >
                                                                                    {quizCompleted[subjects[0].id]
                                                                                        ? quizResults[subjects[0].id] !== undefined
                                                                                            ? quizResults[subjects[0].id]
                                                                                                ? "✅"
                                                                                                : "❌"
                                                                                            : "✅"
                                                                                        : "🤔"}{" "}
                                                                                    Compris ?..
                                                                                </Button>
                                                                            )}

                                                                            {attachmentsMap[subjects[0].id] && attachmentsMap[subjects[0].id].length > 0 && (
                                                                                <Button
                                                                                    type="primary"
                                                                                    // icon={<PaperClipOutlined />}
                                                                                    // onClick={() => handleSubjectSelection(subjects[0], "attachments")}
                                                                                    onClick={openAttachmentsModal}
                                                                                    style={{
                                                                                        backgroundColor: "#3f51b5",
                                                                                        borderColor: "#3f51b5",
                                                                                        color: "#fff",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        gap: "8px",
                                                                                        padding: "6px 12px",
                                                                                        borderRadius: "10px",
                                                                                        fontWeight: "bold",
                                                                                        fontSize: "16px",
                                                                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                                                                        transition: "transform 0.2s ease",
                                                                                    }}
                                                                                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                                                                                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                                                >
                                                                                    📎 Pièces jointes
                                                                                </Button>
                                                                            )}

                                                                            {resourcesMap[subjects[0].id] && resourcesMap[subjects[0].id].length > 0 && (
                                                                                <Button
                                                                                    type="default"
                                                                                    // icon={<ReadOutlined />}
                                                                                    // onClick={() => handleSubjectSelection(subjects[0], "resources")}
                                                                                    onClick={openResourcesModal}
                                                                                    style={{
                                                                                        backgroundColor: "#4caf50",
                                                                                        borderColor: "#4caf50",
                                                                                        color: "#fff",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        gap: "8px",
                                                                                        padding: "6px 12px",
                                                                                        borderRadius: "10px",
                                                                                        fontWeight: "bold",
                                                                                        fontSize: "16px",
                                                                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                                                                        transition: "transform 0.2s ease",
                                                                                    }}
                                                                                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                                                                                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                                                >
                                                                                    📚  Ressource externe
                                                                                </Button>
                                                                            )}


                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            );




                                                        })}




                                                    </Collapse>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </Collapse>
                                    <div style={{ textAlign: "center", marginBottom: "15px" }}>
                                        {/* <Button
                                            type="default"
                                            onClick={() => setIsTrainingsModalVisible(true)}
                                            // disabled={trainings.length === 0}
                                            style={{
                                                backgroundColor: "#e3f2fd",
                                                color: "#0d47a1",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                padding: "10px 12px",
                                                borderRadius: "8px",
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {`📘 Entraînez-vous (${trainings.length})`}

                                        </Button> */}
                                        <Button
                                            type="default"
                                            onClick={async () => {
                                                await fetchTrainings(); // 🔁 recharge les derniers exercices
                                                setIsTrainingsModalVisible(true); // ✅ puis ouvre la modale
                                            }}
                                            style={{
                                                backgroundColor: "#e3f2fd",
                                                color: "#0d47a1",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                padding: "10px 12px",
                                                borderRadius: "8px",
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {`📘 Entraînez-vous (${trainings.length})`}
                                        </Button>

                                    </div>
                                </Card>

                            </div>


                            <div style={{ flex: "1 1 80%", padding: "15px", overflowY: "auto" }}>
                                {/* <Card title={<Text strong>Contenu Sélectionné</Text>}>
                                    <div dangerouslySetInnerHTML={{ __html: selectedContent || "Veuillez sélectionner un contenu." }} />
                                </Card> */}
                                {/* <Card title={<Text strong>Contenu Sélectionné</Text>}>
                                    <div dangerouslySetInnerHTML={{ __html: sanitizeAndModifyContent(selectedContent) }} />
                                </Card> */}
                                {/* <Card title={<Text strong>Contenu Sélectionné</Text>}>
                                    <div dangerouslySetInnerHTML={{ __html: sanitizeAndModifyContent(selectedContent) || "Aucun contenu disponible." }} />
                                </Card> */}
                                {/* <Card title={<Text strong>Contenu Sélectionné</Text>}>
                                    <div ref={contentRef} dangerouslySetInnerHTML={{ __html: sanitizeAndModifyContent(selectedContent) || "Aucun contenu disponible." }} />
                                </Card> */}



                                <Card style={{
                                    background: "#ffffff",
                                    padding: "20px",
                                    borderRadius: "10px",
                                    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)"
                                }}>
                                    <h3 style={{ color: "#00796B", fontWeight: "bold" }}>📖 Contenu Sélectionné......</h3>

                                    {/* ✅ Afficher le contenu principal si "full" ou "content" */}
                                    {(displayMode === "full" || displayMode === "content") && (
                                        <div ref={contentRef} dangerouslySetInnerHTML={{ __html: sanitizeAndModifyContent(selectedContent) || "Aucun contenu disponible." }} />
                                    )}

                                </Card>


                                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                                    <Button
                                        type="primary"
                                        size="large"
                                        onClick={() => goToPreviousSubject()}
                                        disabled={isFirstSubject()} // Désactiver si c'est le premier sujet
                                        style={{
                                            background: isFirstSubject() ? "#d9d9d9" : "linear-gradient(45deg, #FF416C, #FF4B2B)",
                                            color: isFirstSubject() ? "#8c8c8c" : "white",
                                            border: "none",
                                            fontWeight: "bold",
                                            padding: "10px 20px",
                                        }}
                                    >
                                        ← Retour
                                    </Button>

                                    <Button
                                        type="primary"
                                        size="large"
                                        onClick={() => goToNextSubject()}
                                        disabled={isLastSubject()}
                                        style={{
                                            background: isLastSubject() ? "#d9d9d9" : "linear-gradient(45deg, #36D1DC, #5B86E5)",
                                            color: isLastSubject() ? "#8c8c8c" : "white",
                                            border: "none",
                                            fontWeight: "bold",
                                            padding: "10px 20px",
                                            transition: "0.3s",
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isLastSubject()) e.currentTarget.style.transform = "scale(1.1)";
                                        }}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1.0)"}
                                    >
                                        Suivant →
                                    </Button>

                                </div>


                            </div>
                        </div>
                    </Tabs.TabPane>




                    {/* 🏆 Tab Évaluations & Contrôles */}
                    <Tabs.TabPane
                        tab={
                            <span>
                                <TrophyOutlined style={{ fontSize: "20px", color: "#4caf50" }} /> Contrôles des connaissances
                            </span>
                        }
                        key="5"
                    >


                        <Card title="Liste des Contrôles des connaissances " style={{ marginTop: "20px" }}>
                            {courseQuizzes.length > 0 ? (
                                <Collapse accordion>
                                    {/* // ✅ Place ce bloc ici juste après */}

                                    {courseQuizzes.map((quiz) => (
                                        
                                        <Collapse.Panel
                                            header={
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <strong>{quiz.title}</strong>
                                                    {/* <span style={{ color: "#4caf50" }}>
                                                        Progression : {quiz.progressPercentage || 0}%
                                                    </span> */}
                                                </div>
                                            }
                                            key={quiz.id}
                                        >
                                            {/* <QuizPreviewComponent quizId={quiz.id} /> */}
                                            {/* <QuizPreviewComponent quizId={quiz.id} attemptOnce={quiz.attempt_once === 1} /> */}
                                            {/* <QuizPreviewComponent quizId={106} attemptOnce={quiz.attemptOnce   === 1} /> */}

                                            {/* <QuizPreviewComponent quizId={quiz.id} attemptOnce={quiz.attempt_once} /> */}
{/* <QuizPreviewComponent quizId={quiz.id} attemptOnce={quiz.attempt_once === 1} /> */}
{/* <QuizPreviewComponent quizId={quiz.id} attemptOnce={true} /> */}
{/* <QuizPreviewComponent quizId={quiz.id} attemptOnce={quiz.attempt_once === 1} /> */}

<QuizPreviewComponent quizId={quiz.id} attemptOnce={quiz.attemptOnce} />

                                            {/* {quiz.questions && quiz.questions.length > 0 ? (
                                                <List
                                                    itemLayout="vertical"
                                                    dataSource={quiz.questions}
                                                    renderItem={(question, index) => (
                                                        <List.Item key={question.id}>
                                                            <Card
                                                                type="inner"
                                                                // title={`Question ${index + 1}: ${question.title || "Question sans titre"}`}
                                                                title={`Question ${index + 1}: ${question.text || question.title || "Question"}`}

                                                            >
                                                                {question.questionType === "QCU" || question.questionType === "VRAI_FAUX" ? (
                                                                    <Radio.Group disabled style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                        {(question.options || []).map((option, idx) => (
                                                                            <Radio key={idx} value={option.text}>
                                                                                {option.text}
                                                                            </Radio>
                                                                        ))}
                                                                    </Radio.Group>
                                                                ) : question.questionType === "QCM" ? (
                                                                    <Checkbox.Group disabled style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                        {(question.options || []).map((option, idx) => (
                                                                            <Checkbox key={idx} value={option.text}>
                                                                                {option.text}
                                                                            </Checkbox>
                                                                        ))}
                                                                    </Checkbox.Group>
                                                                ) : (
                                                                    <div style={{ color: "red" }}>
                                                                        ❗ Type de question non supporté : {question.questionType || "Non spécifié"}
                                                                    </div>
                                                                )}

                                                            </Card>
                                                        </List.Item>
                                                    )}
                                                />
                                            ) : (
                                                <p style={{ color: "red" }}>Aucune question disponible pour ce quiz.</p>
                                            )} */}
                                        </Collapse.Panel>
                                    ))}
                                </Collapse>
                            ) : (
                                <p>Aucun quiz disponible pour ce cours.</p>
                            )}
                        </Card>


                    </Tabs.TabPane>



                </Tabs>
            </div>


            <Modal
                title="📎 Pièces jointes"
                visible={isAttachmentsModalVisible}
                onCancel={closeAttachmentsModal}
                footer={null}
                width="60%"
            >
                {attachmentsMap[selectedSubjectId]?.length > 0 ? (
                    <List
                        grid={{ gutter: 16, column: 2 }}
                        dataSource={attachmentsMap[selectedSubjectId]}
                        renderItem={(item) => (
                            <List.Item>
                                <Card
                                    title={item.fileName}
                                    extra={<Button type="link" href={item.fileUrl} target="_blank" icon={<EyeOutlined />}>Voir</Button>}
                                    style={{ borderRadius: '10px', backgroundColor: '#fafafa' }}
                                >
                                    <p><PaperClipOutlined /> {item.fileName}</p>
                                </Card>
                            </List.Item>
                        )}
                    />
                ) : (
                    <p>Aucune pièce jointe disponible pour ce sujet.</p>
                )}
            </Modal>
            <Modal
                title="📚 Ressources"
                visible={isResourcesModalVisible}
                onCancel={closeResourcesModal}
                footer={null}
                width="60%"
            >
                {resourcesMap[selectedSubjectId]?.length > 0 ? (
                    <List
                        itemLayout="horizontal"
                        dataSource={resourcesMap[selectedSubjectId]}
                        renderItem={(resource) => (
                            <List.Item
                                style={{
                                    backgroundColor: "#fdfcff",
                                    borderRadius: "8px",
                                    padding: "16px",
                                    marginBottom: "10px",
                                    boxShadow: "0 2px 8px rgba(114, 46, 209, 0.08)",
                                }}
                            >
                                <List.Item.Meta
                                    avatar={<BookOutlined style={{ fontSize: "24px", color: "#722ed1" }} />}
                                    title={<span style={{ fontWeight: "bold" }}>{resource.title}</span>}
                                    description={
                                        <div>
                                            {/* Lien vers la ressource si présent */}
                                            {resource.link && (
                                                <div style={{ marginBottom: "8px" }}>
                                                    🔗 <a href={resource.link} target="_blank" rel="noopener noreferrer">{resource.link}</a>
                                                </div>
                                            )}

                                            {/* Contenu HTML de la ressource */}
                                            {resource.content && (
                                                <div
                                                    style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "8px" }}
                                                    dangerouslySetInnerHTML={{ __html: resource.content }}
                                                />
                                            )}
                                        </div>
                                    }
                                />

                            </List.Item>
                        )}
                    />
                ) : (
                    <p>Aucune ressource disponible pour ce sujet.</p>
                )}
            </Modal>

            <Modal
                title={<Text strong>Testez vos connaissances</Text>}
                visible={isQuizModalVisible}
                onCancel={closeQuizModal} // ❌ Ne pas fermer automatiquement
                footer={null}
                width="60%"
            >
                {isQuizLoading ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <Spin size="large" tip="Chargement du quiz..." />
                    </div>
                ) : selectedQuizId ? (
                    <>
                        {/* <QuizComponent key={selectedQuizId} quizId={selectedQuizId} onQuizSubmit={() => handleQuizSubmit(selectedSubjectId)} /> */}
                        <QuizComponent key={selectedQuizId} quizId={selectedQuizId}
                            onQuizSubmit={(isCorrect) => handleQuizSubmit(selectedSubjectId, isCorrect)} />

                        {/* ✅ Affichage du message de succès */}
                        {/* {quizSuccessMessage && (
                            <Alert message={quizSuccessMessage} type="success" showIcon style={{ marginTop: "20px" }} />
                        )} */}

                        {/* ✅ Ajouter un bouton de fermeture pour laisser l'utilisateur fermer lui-même */}
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <Button type="primary" onClick={closeQuizModal}>
                                Fermer
                            </Button>
                        </div>
                    </>
                ) : (
                    <p>Erreur lors du chargement du quiz.</p>
                )}
            </Modal>


            {/* **** gestion des exercices *** */}
            <Modal
                title="📘 Entraînez-vous"
                visible={isTrainingsModalVisible}
                onCancel={() => setIsTrainingsModalVisible(false)}
                footer={null}
                width="60%"
            >
                <TrainingViewer courseId={id} />
            </Modal>



        </>
    );
};

export default CourseDetails;

